import * as React from 'react'
import { useActions, useAppSelector } from 'hooks'
import SearchDropdown from 'components/common/SearchDropdown/SearchDropdown'

const GroupingSearchDropdown: React.FC<{
  defaultRegion?: string
  width?: number
  index?: number
  handleStateUpdate?: Function
  isTableView?: boolean
}> = ({ width = 220 }) => {
  const { setGrouping } = useActions()
  const { currentGrouping, groupingList } = useAppSelector(({ vibrancy }) => vibrancy.configuration.grouping)

  const handleChangeCountry = (event: React.SyntheticEvent, value: any) => {
    setGrouping(value)
  }

  return (
    <SearchDropdown
      id='grouping-dropdown'
      size='small'
      value={currentGrouping}
      handleStateUpdate={handleChangeCountry}
      data={groupingList.map((el) => ({ value: el, isDisabled: false }))}
      width={width}
      height={32}
      fontSize={15}
    />
  )
}
export default GroupingSearchDropdown
